function TextButton({ Component = 'button', ...props }) {
	return (
		<Component
			className="px-1 py-2.5 text-xs text-black transition-colors hover:text-black sm:text-xs"
			{...props}
		/>
	);
}

export default TextButton;
